const VOUCHERS_PENDING = 'vouchers_pending';
const VOUCHERS_FAILED = 'vouchers_failed';
const VOUCHERS_DOWNLOADED = 'vouchers_downloaded';
const VOUCHERS_RESET = 'vouchers_reset';
const VOUCHER_SENDING = 'voucher_sending';
const VOUCHER_DOWNLOADED = 'voucher_downloaded';
const VOUCHER_REMOVED = 'voucher_removed';

export {
  VOUCHERS_PENDING,
  VOUCHERS_FAILED,
  VOUCHERS_DOWNLOADED,
  VOUCHERS_RESET,
  VOUCHER_SENDING,
  VOUCHER_DOWNLOADED,
  VOUCHER_REMOVED,
};



// WEBPACK FOOTER //
// ./src/store/vouchers/types.js